export const SITE_STATES_LABELS = {
    Archived: 'Archivé',
    Regular: 'Actif',
};
